module.exports = __webpack_public_path__ + "img/gm.48009a2f.svg";